import { Injectable } from '@angular/core';
import { CanActivate, Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { AuthService } from '../auth.service';

@Injectable()
export class AppReportGuard implements CanActivate {
    constructor(private authService: AuthService, private router: Router) {}
    canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (!this.authService || !this.authService.isAuthenticated()) {
            this.authService.redirectUrl = state.url;
            this.router.navigate(['auth/login'], {
                queryParams: { returnUrl: state.url },
            }).then(() => {});
            return false;
        } else {
            const currentUser = this.authService.getCurrentUser();
            return true;
        }
    }
}
